import React, { useState, useCallback } from 'react';
import { PapiUser, PapiDeviation, PapiGallection } from '@wix/da-papi-types';
import GroupGallectionSelector from '../../../GroupGallectionSelector';
import { GroupGallectionType } from '../../../GroupGallectionSelector/redux/types';
import MediaSelector, { Props as MediaSelectorProps } from '../../MediaSelector/MediaSelector';

export interface Props extends Omit<MediaSelectorProps, 'onSelect'> {
  group: PapiUser;
  gallectionType?: 'gallery' | 'collection';
  initialGroupGallection?: PapiGallection;
  onSelect: (
    deviations: PapiDeviation[],
    group: PapiUser,
    type: GroupGallectionType,
    folderid?: number
  ) => void;
}

const MediaSelectorWithGroupGallection: React.FC<Props> = ({
  group,
  gallectionType = 'gallery',
  initialGroupGallection = undefined,
  onSelect,
  ...props
}) => {
  const [selectedGallection, setSelectedGallection] = useState<PapiGallection | undefined>(
    initialGroupGallection
  );
  const onGroupGallectionSelect = useCallback(gallection => setSelectedGallection(gallection), []);
  const onSelectCallback = useCallback(
    deviations => onSelect(deviations, group, gallectionType, selectedGallection?.folderId),
    [onSelect, group, gallectionType, selectedGallection]
  );

  return (
    <MediaSelector
      {...props}
      subheading={
        <GroupGallectionSelector
          group={group}
          gallectionType={gallectionType}
          selected={selectedGallection}
          onSelect={onGroupGallectionSelect}
        />
      }
      onSelect={onSelectCallback}
    />
  );
};
MediaSelectorWithGroupGallection.displayName = 'MediaSelectorWithGroupGallection';

export default MediaSelectorWithGroupGallection;
